
















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { exportToCSV, DatabaseHeader } from './tables/database';

import * as BOX_STYLES_QUERY from 'src/graphql/admin/BoxStyles.graphql';

@Component({
  apollo: {
    box_styles: {
      query: BOX_STYLES_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class BoxDatabase extends Vue {
  search = '';

  headers: DatabaseHeader[] = [
    { text: 'Name',             value: 'name',        class: 'fixed-column' },
    { text: 'Description',      value: 'description', class: 'description-header' },
    { text: 'FEM Code',         value: 'fem_code' },
    { text: 'iFEM',             value: 'i_fem' },
    { text: 'Buckl. Modes',     value: 'buckling_modes' },
    { text: 'Ult. Load Const.', value: 'ultimate_load_constant' },
    { text: 'Crush Const.',     value: 'crush_constant' },
  ];

  box_styles = [];

  onExport() {
    exportToCSV('Boxes', this.headers, this.box_styles);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/BoxDatabase.vue